export default __webpack_public_path__ + "static/media/xwiki.d3b06e88.svg";